<script lang="ts">
	import type { LookalikeModelRow } from 'Lookalike';
	import { Link } from 'svelte-routing';

	export let row: LookalikeModelRow;
</script>

{#if row.status === 'SUCCESS'}
	<Link to="/lookalike_targeting/detail/{row.id}">DETAIL</Link>
{/if}
